import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

 ROLE_OL_ADMINISTRATEUR = "ROLE_OL_ADMINISTRATEUR";
 ROLE_OL_VIEWER = "ROLE_OL_VIEWER";
 ROLE_D_VIEWER = "ROLE_D_VIEWER";

  httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient, private _router: Router) { }

  ngOnInit() { }

  loginCredentials(username, password): Observable<Object> {
    return this.http.post<Object>(environment.ApiUrl + "login/credentials", { 'username': username, 'password': password }, { headers: this.httpHeaders });
  }

  loginAuthCode(username, authCode): Observable<Object> {
    return this.http.post<Object>(environment.ApiUrl + "login/auth-code", { 'username': username, 'auth_code': authCode }, { headers: this.httpHeaders });
  }

  isLoggedIn() {
    return this.getToken() != null;
  }

  setToken = (token) => {
    localStorage.setItem('token', token);
  }

  getToken = () => {
    return localStorage.getItem('token');
  }

  setRoles(roles: string[]) {
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  getRoles(): string[] {
    const roles = localStorage.getItem('roles');
    return roles ? JSON.parse(roles) : [];
  }

  setSites(sites: string[]) {
      localStorage.setItem('sites', JSON.stringify(sites));
  }

  getSites(): string[] {
      const sites = localStorage.getItem('sites');
      return sites ? JSON.parse(sites) : [];
  }

  isViewer(): boolean {
      const roles = this.getRoles();
      return roles.includes(this.ROLE_OL_VIEWER) || roles.includes(this.ROLE_D_VIEWER);
  }

  clearLocalStorage = () => {
    localStorage.clear();
  }
}
